<template>
	<div class="finance-car-card">
		<div class="finance-car-info">
			<div>
				<div class="finance-car-name">{{ carName }}</div>
				<div class="finance-car-configs">{{ configSummary }}</div>
			</div>
			<div class="finance-car-price">
				¥ {{ formatCurrency(car.sell_programme && car.sell_programme.sell_price) }}
			</div>
		</div>
		<nio-image
			v-if="carImage"
			class="finance-car-image"
			:image-style="{ objectFit: 'cover' }"
			:src="cdn(carImage, '/thumbnail/!500x300r', true)"
		/>
	</div>
</template>

<script>
import { BrandMap } from '@/util/constant'
import util from '@/util/util'
import { cdn } from '@/util/imgCdn'

export default {
	name: 'FinanceCarCard',
	props: {
		car: {
			type: Object,
			required: true
		}
	},
	computed: {
		carName() {
			const basic = this.car.basic || {}
			const name = basic.commodity_name || ''
			const brand = BrandMap[basic.brand]
			return brand ? brand + ' ' + name : name
		},
		configSummary() {
			const configs = (this.car.basic && this.car.basic.all_configs) || []
			return configs
				.map(item => item.name)
				.filter(Boolean)
				.join('｜')
		},
		carImage() {
			return (this.car.basic && this.car.basic.commodity_head_photo) || ''
		}
	},
	methods: {
		formatCurrency: util.formatCurrency,
		cdn
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-car-card {
	position: relative;
	height: 167px;
	padding: 20px;
	background: var(--bg_secondary);
	margin: 0 20px;
}

.finance-car-info {
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 127px;
}

.finance-car-name {
	@include subtitle_3(1.5, 500, false);
	color: var(--text_primary);
}

.finance-car-configs {
	width: 100%;
	overflow: hidden;
	margin-top: 5px;
	@include body_3(1.5, 400, false);
	color: var(--text_secondary);
	text-overflow: ellipsis;
	white-space: nowrap;
}

.finance-car-price {
	@include subtitle_2(1.2, 700);
	color: var(--text_primary);
}

.finance-car-image {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 161px;
	height: 96px;
	object-fit: cover;
}
</style>
